/** Legacy FFmpeg output and its timeline use the same frame rate. */
export const LEGACY_TIMELINE_FPS = 24

export function stepTimelineFrame(time: number, direction: -1 | 1, fps: number, duration: number, bySecond = false): number {
  if (!Number.isFinite(fps) || fps <= 0) throw new Error('Timeline FPS must be positive')
  const frame = Math.round(time * fps)
  const delta = bySecond ? Math.round(fps) : 1
  return Math.max(0, Math.min(Math.max(0, Math.ceil(duration * fps) - 1), frame + direction * delta)) / fps
}
